import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";

import { PiniaVuePlugin } from "pinia";

import "./images.ts";

Vue.config.devtools = true;

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(PiniaVuePlugin);
